<template lang="pug">
    
  v-navigation-drawer(v-model="visible" fixed clipped app right disable-resize-watcher touchless)
    v-list(two-line)
      v-btn.readall(v-if="total > 0" block text @click.prevent="markAllRead") {{ $t("notification.mark_all_as_read") }}
      template(v-for="(notification, index) in items")
        v-divider
        v-list-item(:key="index" @click="clickItem(notification)")
          v-list-item-avatar: v-icon {{ notification.icon }}
          v-list-item-content
            v-list-item-title {{ notification.title }}
            v-list-item-subtitle {{ notification.text }}
            v-list-item-subtitle: timeago(:datetime="notification.created_at" :auto-update="30")

      //- v-divider(v-if="total > 5 && !showAll")
      //- v-btn(block text v-if="total > 5 && !showAll" @click="toggleShowAll") View All

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {

  data() {
    return {
      visible: false,
      showAll: false,
    }
  },

  computed: {
    ...mapGetters('entities/notifications', [
      'items',
    ]),
    total() {
      return this.items.length
    },
  },

  watch: {
    total(total) {
      if(total == 0) this.visible = false
    }
  },

  mounted() {
    this.registerServiceWorker()
  },

  methods: {
    ...mapActions('entities/notifications', [
      'markAsRead',
      'markAllRead',
    ]),
    ...mapActions('webpush', [
      'registerServiceWorker',
      'unsubscribe',
    ]),

    clickItem(item) {
      this.markAsRead(item)
      if(item.task_id && item.action != 'deleted') {
        if(this.$route.name == 'traffic' && this.$route.params.task == item.task_id) return
        this.$router.push({
          name: 'traffic',
          params: {
            task: item.task_id
          }
        })
      }
    },

    toggleShowAll(){
      this.showAll = !this.showAll
    },
  }
}
</script>